import { lazy } from 'react';

import Loadable from 'components/Loadable';
import { ROUTES } from 'utils/constant';
import MainLayout from 'layout/MainLayout';

const Dashboard = Loadable(lazy(() => import('pages/dashboard')));
const Admin = Loadable(lazy(() => import('pages/admin')));
const Assessment = Loadable(lazy(() => import('pages/assessment')));
const PromptCategory = Loadable(lazy(() => import('pages/promptCategory')));
const Leaders = Loadable(lazy(() => import('pages/leaders')));
const Prompts = Loadable(lazy(() => import('pages/prompts')));
const Question = Loadable(lazy(() => import('pages/question')));
const Role = Loadable(lazy(() => import('pages/role')));
const User = Loadable(lazy(() => import('pages/user')));
const NewUser = Loadable(lazy(() => import('pages/newUser')));
const UserDetail = Loadable(lazy(() => import('pages/userDetail')));
const DeletedUsers = Loadable(lazy(() => import('pages/deletedUsers')));
const PromptDataModals = Loadable(lazy(() => import('pages/promptDataModals')));
const Feedback = Loadable(lazy(() => import('pages/feedback')));
const ReAssessmentRequests = Loadable(lazy(() => import('pages/reassessmentRequests')));
const Email = Loadable(lazy(() => import('pages/email')));
const SupportTickets = Loadable(lazy(() => import('pages/supportTickets')));
const PersonalityArchetypes = Loadable(lazy(() => import('pages/personalityArchetypes')));

const ProtectedRoute = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: ROUTES.DASHBOARD,
            element: <Dashboard />,
        },
        {
            path: ROUTES.ADMIN,
            element: <Admin />,
        },
        {
            path: ROUTES.ASSESSMENT,
            element: <Assessment />,
        },
        {
            path: ROUTES.PROMPT_CATEGORY,
            element: <PromptCategory />,
        },
        {
            path: ROUTES.LEADERS,
            element: <Leaders />,
        },
        {
            path: ROUTES.PROMPTS,
            element: <Prompts />,
        },
        {
            path: ROUTES.PROMPT_DATA_MODALS,
            element: <PromptDataModals />,
        },
        {
            path: ROUTES.QUESTION,
            element: <Question />,
        },
        {
            path: ROUTES.ROLE,
            element: <Role />,
        },
        {
            path: ROUTES.USER,
            element: <User />,
        },
        {
            path: ROUTES.NEW_USER,
            element: <NewUser />,
        },
        {
            path: ROUTES.USER_DETAILS,
            element: <UserDetail />,
        },
        {
            path: ROUTES.DELETED_USERS,
            element: <DeletedUsers />,
        },
        {
            path: ROUTES.FEEDBACK,
            element: <Feedback />,
        },
        {
            path: ROUTES.RE_ASSESSMENT_REQUESTS,
            element: <ReAssessmentRequests />,
        },
        {
            path: ROUTES.EMAIL,
            element: <Email />,
        },
        {
            path: ROUTES.SUPPORT_TICKETS,
            element: <SupportTickets />,
        },
        {
            path: ROUTES.PERSONALITY_ARCHETYPES,
            element: <PersonalityArchetypes />,
        }
    ],
};

export default ProtectedRoute;